import { useState, useEffect, useRef } from "react";
import { Formik, setFieldValue, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Controls from "../../components/FormsUI";
import { useAuth } from "../../utility/auth";
import ImagePreview from "../../components/FormsUI/PreviewImage/index";
import DoctorController from "../../controller/DoctorController";
import AssociateController from "../../controller/DoctorAssociateController";
import MasterController from "../../controller/MastersController";
import CustomizedSnackbars from "../../components/Alert";
import EditIcon from "@mui/icons-material/Edit";
import Load from "../../components/FormsUI/Loader/index";//../components/FormsUI/Loader/index
import DeleteIcon from "@mui/icons-material/Delete";
import "../../css/style.css";
import { tokens } from "../../theme";
import {
    Container,
    Grid,
    useTheme,
    Box,
    Stack,
    IconButton,
} from "@mui/material";
import ExceptionHandlerController from "../../controller/ErrorLogsController";


const INITIAL_FORM_STATE = {
    doctorId: "",
    associateName: "",
    associateTitle: "",
    associateEmail: "",
    associateMobile: "",
    associateAddress1: "",
    associateAddress2: "",
    associateCity: "",
    associateState: "",
    associatePin: "",
    associateGST: "",
    associatePAN: "",

    associateCertificate: null,
};
const FORM_VALIDATION = Yup.object().shape({
    doctorId: Yup.string()
        .matches(/^[0-9a-fA-F]{24}$/, "Invalid  DoctorId format") // ✅ Only for ObjectId
        .required("Doctor name is required"),
    associateName: Yup.string()
        .matches(/^[A-Za-z ]*$/, "Associate Name is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(3, "Minimum 3 characters required")
        .max(100, "Associate Name should not exceed 100 characters")
        .required("Associate Name is required"),

    associateTitle: Yup.string()
        .matches(/^[A-Za-z0-9 .]*$/, "Associate Title  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(20, "Associate Title  should not exceed 20 characters")
        .required("Associate Title  is required"),

    associateEmail: Yup.string()
        .email("Associate Email is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .required("Associate Email is required"),

    associateMobile: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Associate Mobile is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .required("Associate Mobile is required"),
    associateAddress1: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "Associate Address1  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(200, "Associate Address1 should not exceed 50 characters")
        .optional(),
    associateAddress2: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "Associate Address2  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(200, "Associate Address2 should not exceed 50 characters")
        .optional(),
    associateCity: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "Associate City  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(20, "Associate City should not exceed 50 characters")
        .optional(),
    associateState: Yup.string()
        .matches(/^[A-Za-z0-9 ]*$/, "Associate State  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(20, "Associate State should not exceed 50 characters")
        .optional(),
    associatePin: Yup.string()
        .matches(/^[0-9 ]*$/, "Associate PinCode  is not in correct format")
        .trim("No white space allowed")
        .strict(true)
        .min(2, "Minimum 2 characters required")
        .max(20, "Associate PinCode should not exceed 50 characters")
        .optional(),
    associateGST: Yup.string()
        .matches(
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
            "Enter a valid GST number (e.g., 22AAAAA0000A1Z5)"
        )
        // .required("GST number is required"),
        .optional(),
    associatePAN: Yup.string()
        .matches(
            /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            "Associate PAN is not in correct format (e.g., ABCDE1234F)"
        )
        .trim("No white space allowed")
        .strict(true)
        .optional(),
    // .required("Associate PAN is required"),
    associateCertificate: Yup.mixed().optional(),

});

let requestType = "";
const DoctorAssociate = () => {
    const fileInputRef = useRef(null);
    const doctorController = new DoctorController();
    const associateController = new AssociateController();
    const masterController = new MasterController();
    const exceptionHandlerController = new ExceptionHandlerController();
    const auth = useAuth();
    const user = auth.decoder(sessionStorage.getItem("user"));
    const { data, token } = user;
    const { userid: userId, tenantid: tenantId } = data.UserInfo;
    const [doctorOptions, setDoctorOptions] = useState()
    const [associateData, setAssociateData] = useState([])
    const [associateCertificate, setAssociateCertificate] = useState();
    const [popupPreview, setPopUpPreview] = useState({
        associateCertificate: false
    });
    const previewPopUpImage = (field, value) =>
        setPopUpPreview((prev) => ({ ...prev, [field]: value }));
    const [loader, setLoader] = useState(true);
    const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
    const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
    const [popup, setPopUp] = useState(false);
    const [allData, setAllData] = useState([]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    useEffect(() => {
        getAllAssociate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const getPinCodeData = async (pin, setFieldValue) => {
        let caughtError;
        try {
            const pinData = { pincode: Number(pin) };
            const pinResponse = await masterController.GetLocation(pinData)
            if (pinResponse.status === 200) {
                const pinRes = pinResponse?.data?.body?.pincode;
                setFieldValue("associateCity", pinRes?.city || "");
                setFieldValue("associatePin", String(pinRes?.pincode) || "");
                setFieldValue("associateState", pinRes?.state || "");
            }
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getPinCodeData",
            };
            exceptionHandlerController.HandleException(logError);
        }
    }

    const getAllAssociate = async () => {
        let caughtError;
        try {
            const response = await associateController.GetAllAssociate(token);
            if (response.status === 200) {
                const associateData = response?.data?.body?.map((item) => ({
                    ...item,
                    id: item._id,
                }));
                setAssociateData(associateData);
            }
            else if (response?.data?.status === 404) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllAssociate",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };
    const getAllDoctor = async () => {
        let caughtError;
        try {
            const response = await doctorController.GetAllDoctor(token);
            if (response.status === 200) {
                const docData = response?.data?.body?.map((item) => ({
                    doctorName: item.doctorName,
                    doctorId: item._id,
                }));
                setDoctorOptions(docData);
            }
            else if (response?.data?.status === 404) {
                showAlert("error", response?.data?.message);
            } else if (response?.status === 500) {
                showAlert("error", response?.response?.data?.message);
            }
            setLoader(() => false);
        } catch (error) {
            caughtError = error;
            let logData = {};
            logData.message = caughtError?.message;
            logData.stack = caughtError?.stack;
            let logError = {
                logData,
                module: "getAllDoctor",
            };
            exceptionHandlerController.HandleException(logError);
        }
    };

    const saveFile = ({ e, setFieldValue, field }) => {
        const file = e.currentTarget.files[0];
        if (!file) return;

        const fileSizeInMB = file.size / (1024 * 1024);
        if (fileSizeInMB > 4) {
            showAlert("error", "Document size should not be more than 4MB");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            return;
        }

        const extFile = getFileExtension(file.name);
        if (!isValidImageExtension(extFile)) return;

        const reader = new FileReader();
        const WIDTH = 1024;
        const IMAGE_H = 682;
        reader.onload = (event) => {
            const image = new Image();
            image.onload = () => {
                const width = image.naturalWidth;
                const height = image.naturalHeight;
                const aspectRatio = width / height;

                const REQUIRED_ASPECT_RATIO = 1024 / 682;
                const TOLERANCE = 0.3;

                if (Math.abs(aspectRatio - REQUIRED_ASPECT_RATIO) > TOLERANCE) {
                    showAlert(
                        "error",
                        `Invalid aspect ratio. Required: ${WIDTH}x${IMAGE_H} (${REQUIRED_ASPECT_RATIO.toFixed(2)})`
                    );
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    return;
                }
                // If all checks pass
                setAssociateCertificate(event.target.result);
                setFieldValue(field, file);
            };

            image.onerror = () => {
                showAlert("error", "Invalid image file.");
            };

            image.src = event.target.result;
        };

        reader.readAsDataURL(file);
    };

    const getFileExtension = (filename) => {
        return filename.split(".").pop().toLowerCase();
    };
    const isValidImageExtension = (ext) => {
        const validExtensions = ["jpg", "jpeg", "png"];
        if (!validExtensions.includes(ext)) {
            showAlert("error", "Only jpeg, png and jpg images are allowed");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
            return false;
        }
        return true;
    };


    const showAlert = (type, msg) => {
        const notify = { ...alert };
        notify.counter = notify.counter + 1;
        notify.type = type;
        notify.msg = msg;
        setAlert(notify);
    };

    const columns = [
        {
            headerName: "ID",
            field: "id",
            hide: true,
            filterable: false,
            width: 210,
        },
        { headerName: "Associate Name", field: "associateName", width: 210 },
        { headerName: "Associate Title ", field: "associateTitle", width: 210 },
        { headerName: "Associate Email", field: "associateEmail", width: 210 },
        { headerName: "Associate Mobile", field: "associateMobile", width: 210 },
        {
            field: "action",
            headerName: "Action",
            width: 210,
            sortable: false,
            filterable: false,
            disableExport: true,
            disableClickEventBubbling: true,

            renderCell: (params) => {
                const onClick = (e, type) => {
                    let caughtError;
                    try {
                        setAlert({ counter: 0, type: "", msg: "" });
                        const currentRow = params?.row;
                        if (type === "Edit") {
                            requestType = "Edit";
                            setUpdatedValues(() => currentRow);
                            const currentRowData = currentRow;
                            setUpdatedValues(() => currentRowData);
                            setAssociateCertificate(currentRow.associateCertificate)
                            setDoctorOptions([{
                                doctorName: currentRow.doctorName,
                                doctorId: currentRow.doctorId
                            }]);
                            getAllDoctor();
                            handleData();
                        } else {
                            associateController
                                .Delete(currentRow.id, token)
                                .then((response) => {
                                    if (response.status === 200) {
                                        getAllAssociate()
                                        showAlert("success", "Deleted successfully");
                                        setAllData((i) => {
                                            return allData.filter(
                                                (item) => item?.id !== currentRow.id
                                            );
                                        });
                                    } else if (response.data.status === 404) {
                                        showAlert("error", response.data.message);
                                    }
                                    else if (response?.status === 500) {
                                        showAlert("error", response?.response?.data?.message);
                                    }
                                })
                                .catch((error) => {
                                    showAlert("error", "Oops something went wrong.");
                                    setTimeout(() => {
                                        setAlert({ counter: 0, type: "", msg: "" });
                                    }, 10000);
                                });
                        }
                    } catch (error) {
                        caughtError = error;
                        let logData = {};
                        logData.message = caughtError?.message;
                        logData.stack = caughtError?.stack;
                        let logError = { logData, module: "DoctorDoctorAssociateA onClick(Edit) method" };
                        exceptionHandlerController.HandleException(logError);
                    }
                };

                return (
                    <Stack direction="row" spacing={2}>
                        <>
                            <IconButton onClick={(e) => onClick(e, "Edit")}>
                                <EditIcon type="button" color="primary" id="Edit" />
                            </IconButton>
                            <IconButton>
                                <DeleteIcon
                                    type="button"
                                    color="secondary"
                                    id="Delete"
                                    onClick={(e) => onClick(e, "Delete")}
                                />
                            </IconButton>
                        </>
                    </Stack>
                );
            },
        },
    ];

    const AddDoctorAssociate = async () => {
        getAllDoctor()
        requestType = "Add";
        setUpdatedValues(() => INITIAL_FORM_STATE);
        setAssociateCertificate(null)
        handleData();
    };


    const submitValues = (submitValueData) => {
        let submitData = new FormData();
        // tenantId coming from parent/component
        submitData.append("tenantId", tenantId);
        // Map form fields
        submitData.append("doctorId", submitValueData?.doctorId?.trim());
        submitData.append("associateName", submitValueData?.associateName?.trim() ?? "");
        submitData.append("associateTitle", submitValueData?.associateTitle?.trim() ?? "");
        submitData.append("associateEmail", submitValueData?.associateEmail?.trim() ?? "");
        submitData.append("associateMobile", submitValueData?.associateMobile?.trim() ?? "");
        submitData.append("associateAddress1", submitValueData?.associateAddress1?.trim() ?? "");
        submitData.append("associateAddress2", submitValueData?.associateAddress2?.trim() ?? "");
        submitData.append("associateCity", submitValueData?.associateCity?.trim() ?? "");
        submitData.append("associateState", submitValueData?.associateState?.trim() ?? "");
        submitData.append("associatePin", submitValueData?.associatePin?.trim() ?? "");
        submitData.append("associateGST", submitValueData?.associateGST?.trim() ?? "");
        submitData.append("associatePAN", submitValueData?.associatePAN?.trim() ?? "");
        submitData.append("associateCertificate", submitValueData?.associateCertificate ?? "");

        //add for image
        if (requestType === "Edit") {
            // debugger
            submitData.append("id", submitValueData?.id);
            const associateId = submitValueData?.id;
            // assuming ID comes from backend
            associateController
                .Update(associateId, submitData, token)
                .then((response) => {
                    if (response.status === 200) {
                        getAllAssociate()
                        showAlert("success", response?.data?.message);
                        handlePopup(false);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                        // getAllCenters();
                    } else {
                        if (response?.response?.data?.status === 400)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.response?.status === 409)
                            showAlert("error", response?.response?.data?.message);
                        else if (response?.response?.status === 500)
                            showAlert("error", response?.response?.data?.message);

                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    }
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        } else {
            associateController
                .Create(submitData, token)
                .then((response) => {
                    if (response?.status === 201) {
                        getAllAssociate()
                        handlePopup(false);
                        showAlert("success", response?.data?.message);
                        setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                    } else if (response?.response?.status === 500) {
                        showAlert("error", response?.response?.data?.message);
                    } else if (response?.response?.status === 400) {
                        showAlert("error", response?.response?.data?.message);
                    }
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                })
                .catch((error) => {
                    showAlert("error", "Oops something went wrong.");
                    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
                });
        }
    };


    const handlePopup = (value) => setPopUp(() => value);
    const handleData = () => setPopUp(() => true);
    if (loader) return <Load />;
    return (
        <>
            <Box
                sx={{
                    "& .formBg": {
                        border: `1px solid ${colors.grey[900]}`,
                        background: `${colors.primary[400]}`,
                    },
                    "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
                    "& .MuiGrid-root.Mui-heading h2": {
                        color: `${colors.primary[200]} !important`,
                    },
                }}
            >
                <Grid container>
                    <Grid className="breadcrumb-section">
                        <Grid className="breadcrumb-container">
                            <Grid className="Mui-li">
                                <nav className="Mui-nav" aria-label="breadcrumb">
                                    <ol className="">
                                        <li className="MuiBreadcrumbs-li">
                                            <h6 className="breadsub">Medical</h6>
                                        </li>
                                        <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                                            /
                                        </li>
                                        <li className="MuiBreadcrumbs-li">
                                            <h6>Doctor Associate</h6>
                                        </li>
                                    </ol>
                                </nav>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} className="adduser">
                        <Controls.ActionButton onClick={() => AddDoctorAssociate()}>
                            <span>Add New</span>
                        </Controls.ActionButton>
                    </Grid>
                    <Grid item xs={12} className="formBg">
                        <Container maxWidth="md" className="formClwidth">
                            <div>
                                <Controls.Grid
                                    columns={columns}
                                    data={associateData}
                                    fileName={"Users"}
                                />
                                {popup && (
                                    <Controls.Popup
                                        title="Doctor Associate Details"
                                        openPopup={popup}
                                        setOpenPopup={handlePopup}
                                    >
                                        <Formik
                                            enableReinitialize
                                            initialValues={{
                                                ...(updatedValues || INITIAL_FORM_STATE),
                                            }}
                                            validationSchema={FORM_VALIDATION}
                                            onSubmit={(values) => submitValues(values)}
                                        >
                                            {({ values, handleChange, setFieldValue }) => (
                                                <Form>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="associateName"
                                                                label="Associate Name"
                                                                type="string"
                                                                inputProps={{ maxLength: 100 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="associateTitle"
                                                                label="Associate Title "
                                                                type="string"
                                                                inputProps={{ maxLength: 50 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="associateMobile"
                                                                label="Associate Mobile"
                                                                type="string"
                                                                inputProps={{
                                                                    maxLength: 10,
                                                                    inputMode: "numeric",
                                                                    pattern: "[0-9]*",
                                                                }}
                                                                onChange={(e) => {
                                                                    const onlyNumbers = e.target.value.replace(/\D/g, ""); // remove non-digits
                                                                    e.target.value = onlyNumbers;
                                                                    handleChange(e); // keep Formik in sync
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="associateEmail"
                                                                label="Associate Email"
                                                                type="string"
                                                                inputProps={{ maxLength: 50 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.AutoComplete
                                                                name="doctorId"
                                                                value={
                                                                    doctorOptions?.find(
                                                                        (opt) => opt.doctorId === values.doctorId) || null
                                                                }
                                                                label={
                                                                    <span>
                                                                        Select doctor <span className="asterisk">*</span>
                                                                    </span>
                                                                }
                                                                options={doctorOptions || []}
                                                                getOptionLabel={(option) => option?.doctorName || ""}
                                                                isOptionEqualToValue={(option, value) => option?.doctorId === value?.doctorId}
                                                                onChange={(event, value) => {
                                                                    setFieldValue("doctorName", value ? value.doctorName : ""); // ✅ only save string
                                                                    setFieldValue("doctorId", value ? value.doctorId : ""); // ✅ only save string
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="associatePAN"
                                                                label="Associate PAN"
                                                                type="string"
                                                                inputProps={{
                                                                    maxLength: 50,
                                                                    style: { textTransform: "uppercase" }, // UI always shows uppercase
                                                                }}
                                                                onInput={(e) => {
                                                                    e.target.value = e.target.value.toUpperCase();
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="associateGST"
                                                                label="Associate GST"
                                                                type="string"
                                                                inputProps={{ maxLength: 50 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="associatePin"
                                                                label="Associate PinCode"
                                                                type="string"
                                                                inputProps={{ maxLength: 6, inputMode: "numeric", pattern: "[0-9]*" }}
                                                                onChange={(e) => {
                                                                    // ✅ allow only digits
                                                                    const value = e.target.value.replace(/\D/g, ""); // remove non-numeric characters
                                                                    e.target.value = value; // update input with only digits

                                                                    handleChange(e); // keep Formik in sync

                                                                    if (/^\d{6}$/.test(value)) {
                                                                        getPinCodeData(value, setFieldValue);
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="associateCity"
                                                                label="Associate City"
                                                                type="string"
                                                                inputProps={{ maxLength: 50 }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="associateState"
                                                                label="Associate State"
                                                                type="string"
                                                                inputProps={{ maxLength: 50 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="associateAddress1"
                                                                label="Associate Address1"
                                                                type="string"
                                                                inputProps={{ maxLength: 50 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <Controls.Textfield
                                                                name="associateAddress2"
                                                                label="Associate Address2"
                                                                type="string"
                                                                inputProps={{ maxLength: 50 }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <h3 className="upload">
                                                                Certificate Image <span className="asterisk">*</span>
                                                            </h3>
                                                            <input
                                                                type="file"
                                                                name="associateCertificate"
                                                                ref={fileInputRef}
                                                                onChange={(e) => {
                                                                    let field = "associateCertificate";
                                                                    saveFile({ e, setFieldValue, field });
                                                                }}
                                                                className="fileupload"
                                                                style={{ width: "70%" }}
                                                            />
                                                            <Grid className="col-lg-2" style={{ float: "right", marginRight: "1px" }}>
                                                                {associateCertificate && (
                                                                    <img
                                                                        src={associateCertificate}
                                                                        width="55"
                                                                        style={{ cursor: "pointer" }}
                                                                        height="55"
                                                                        onClick={() =>
                                                                            setPopUpPreview((prev) => ({
                                                                                ...prev,
                                                                                associateCertificate: true,
                                                                            }))
                                                                        }
                                                                        alt="Logo"
                                                                        className="imgview"
                                                                    />
                                                                )}
                                                                <ImagePreview
                                                                    image={associateCertificate}
                                                                    popup={popupPreview?.associateCertificate}
                                                                    field={"associateCertificate"}
                                                                    handlePopup={previewPopUpImage}
                                                                />
                                                            </Grid>
                                                            <ErrorMessage name="associateCertificate">
                                                                {(msg) => (
                                                                    <div style={{ color: "#d32f2f" }}>{msg}</div>
                                                                )}
                                                            </ErrorMessage>
                                                        </Grid>
                                                        <br />
                                                    </Grid>
                                                    <Grid item xs={4} md={2} className="marginAuto">
                                                        <Controls.Button>Submit</Controls.Button>
                                                    </Grid>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Controls.Popup>
                                )}
                            </div>
                        </Container>
                    </Grid>
                    {alert?.counter > 0 && (
                        <CustomizedSnackbars
                            status={alert?.counter}
                            msg={alert?.msg}
                            type={alert?.type}
                        />
                    )}
                </Grid>
            </Box>
        </>
    );
};

export default DoctorAssociate;
